import React from 'react';
import { X } from 'lucide-react';
export function PainPoints() {
  const problems = ['Redactar informes', 'Completar registros', 'Preparar adaptaciones curriculares', 'Organizar seguimientos', 'Responder mensajes de familias y escuelas', 'Pensar estrategias para situaciones difíciles'];
  return <section className="w-full bg-red-50 py-16 px-4" data-id="element-114">
      <div className="max-w-4xl mx-auto" data-id="element-115">
        <h2 className="text-2xl md:text-4xl font-bold text-red-700 text-center mb-6" data-id="element-116">
          Si sos acompañante pedagógico, probablemente te pasa esto...
        </h2>

        <p className="text-xl text-red-600 text-center mb-4 font-semibold" data-id="element-117">
          Terminás tu jornada... pero tu trabajo no termina.
        </p>

        <p className="text-lg text-red-600 text-center mb-6" data-id="element-118">
          Llegás a casa y todavía tenés que:
        </p>

        <div className="space-y-3 mb-8" data-id="element-119">
          {problems.map((problem, index) => <div key={index} className="flex items-center gap-3 bg-white rounded-lg p-4 shadow-sm border-l-4 border-red-500" data-id="element-120">
              <X className="w-6 h-6 text-red-600 flex-shrink-0" data-id="element-121" />
              <span className="text-gray-800 font-medium" data-id="element-122">{problem}</span>
            </div>)}
        </div>

        <div className="bg-teal-600 text-white rounded-lg p-6 text-center shadow-lg" data-id="element-123">
          <p className="text-2xl md:text-3xl font-bold" data-id="element-124">
            Para eso creamos, este kit eficiente
          </p>
        </div>
      </div>
    </section>;
}